// @flow

import React from 'react';
import { CelebrationPill } from '../CelebrationPill';
import { ListItem } from '../Filter/CelebrationsFilter/style';

type CelebrationItemProps = {
    item: {
      celebrationTitle: string,
      startDate?: string,
      endDate?: string,
      filterValue: string,
      displayDate?: string,
      data: Object,
    },
    handleFilterClick: Function,
    isSelected: boolean,
    happeningNow: boolean,
  }

const CelebrationItem = ({
  item, handleFilterClick, isSelected, happeningNow,
}: CelebrationItemProps) => {
  const handleClick = () => handleFilterClick(
    item.celebrationTitle,
    item.startDate,
    item.endDate,
    item.filterValue,
    item.displayDate,
    item.data,
  );

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <ListItem
      role='button'
      tabIndex={0}
      aria-label={`${item.celebrationTitle}, ${item.displayDate || ''}`}
      aria-pressed={isSelected}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <CelebrationPill
        celebrationTitle={item.celebrationTitle}
        startDate={item.startDate}
        endDate={item.endDate}
        isSelected={isSelected}
        filterValue={item.filterValue}
        happeningNow={happeningNow}
        displayDate={item.displayDate}
      />
    </ListItem>
  );
};

export default CelebrationItem;
